import 'semantic-ui-css/semantic.min.css'
import NavBar from './NavBar';
import { observer } from 'mobx-react-lite';
import './App.css'
import MainPage from '../features/parts/MainPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from './Footer';
import ClubPage from '../features/club/ClubPage';
import TourPage from '../features/tours/TourPage';
import TrufflePage from '../features/truffles/TrufflePage';

function App() {
  return (
    <>
      <NavBar />


      <BrowserRouter>
        <Routes>
          <Route element={<MainPage />} path='' />
          <Route element={<TrufflePage />} path='/truffles' />
          <Route element={<TourPage />} path='/tours' />
          <Route element={<ClubPage />} path='/club' />
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default observer(App);